import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '@/components/shared/ScrollToTop';
import { FloatingChatWidget } from '@/components/shared/FloatingChatWidget';
import { Toaster } from '@/components/ui/sonner';

export const PublicLayout = () => (
  <div className="min-h-screen flex flex-col bg-background">
    <ScrollToTop />
    <Header />
    <main className="flex-1" data-testid="public-main">
      <Outlet />
    </main>
    <Footer />
    <FloatingChatWidget />
    <Toaster position="top-right" richColors closeButton />
  </div>
);
